import React, { Component } from 'react';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gym: this.props.gym
    }
  }

  cheatingTimeDifference(date) {

    let dateobj = new Date(date * 1000);
    if(dateobj === 'Invalid Date') return;

    let seconds = Math.floor((new Date() - dateobj) / 1000);

    let interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
      return interval + " years";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return interval + " months";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return interval + " days";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return interval + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }

  componentDidMount() {
    if(!this.props.gym) return;
    this.setState({
      date: this.props.gym.updated_at,
      code: this.props.gym.invite_code,
      gymName: this.props.gym.display_name,
      gym_pays_membership: this.props.gym.gym_pays_membership
    });
  }

  componentDidUpdate() {
    if(!this.props.gym) return;
    
    if(this.state.date === this.props.gym.updated_at) return;
    this.setState({
      date: this.props.gym.updated_at,
      code: this.props.gym.invite_code,
      gymName: this.props.gym.display_name,
      gym_pays_membership: this.props.gym.gym_pays_membership
    }); 
  }

  render() {
    return(

      <div>
        <div
          className="absolute bottom-1 left-1 z-2">
          <h4 className="ml4 mb2 pt2 ph3 white roboto t-black">Sign up{this.state.gym_pays_membership ? ' for free' : ''} at: btwb.com/signup with code {this.state.code}</h4>
        </div>
      </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Footer.js